import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const useTheme = () => {
  const context = useContext(ThemeContext);

  return context;
};

export default useTheme;
